import { render, staticRenderFns } from "./inflections-table-wide.vue?vue&type=template&id=d73f8fd8&"
import script from "./inflections-table-wide.vue?vue&type=script&lang=js&"
export * from "./inflections-table-wide.vue?vue&type=script&lang=js&"
import style0 from "./inflections-table-wide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d73f8fd8')) {
      api.createRecord('d73f8fd8', component.options)
    } else {
      api.reload('d73f8fd8', component.options)
    }
    module.hot.accept("./inflections-table-wide.vue?vue&type=template&id=d73f8fd8&", function () {
      api.rerender('d73f8fd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflections-table-wide.vue"
export default component.exports